import { defineStore } from 'pinia'
import { getSession, getStore, setSession, setStore } from '../utils/store'
import website from '@/const/website.js'
import DomainApi from '../api/admin/domain'
import { defaultConfig } from '../const/login-configs'
import LocalDeploymentApi from '@/api/admin/local-deployment'

const domainApi = new DomainApi()
const localDeploymentApi = new LocalDeploymentApi()

const getShowTopMenus = () => {
  const stored = getStore({ name: 'showTopMenus' })
  return stored === null || stored === undefined ? true : stored
}

export const useCommonStore = defineStore('common', {
  state: () => ({
    isCollapse: false,
    keyCollapse: false,
    isFullScreen: false,
    isShade: false,
    screen: -1,
    isLock: getSession({ name: 'isLock' }) || false,
    showTag: getSession({ name: 'showTag' }),
    showDebug: getSession({ name: 'showDebug' }),
    showCollapse: getSession({ name: 'showCollapse' }),
    showSearch: getSession({ name: 'showSearch' }),
    showLock: getSession({ name: 'showLock' }),
    showFullScreen: getSession({ name: 'showFullScreen' }),
    showTheme: getSession({ name: 'showTheme' }),
    showColor: getSession({ name: 'showColor' }),
    showMenu: getSession({ name: 'showMenu' }),
    theme: getStore({ name: 'theme' }),
    themeName: getSession({ name: 'themeName' }) || 'theme-white',
    lockPasswd: getSession({ name: 'lockPasswd' }) || '',
    website: website,
    showTopMenus: getShowTopMenus(),
    systemConfigsLoaded: false,
    systemConfigsLoading: false,
    systemConfigs: defaultConfig,
    previewSystemConfig: null,
    localDeploymentTenant: getSession({ name: 'local_deployment_tenant' }) || {}
  }),
  actions: {
    setCollapse() {
      this.isCollapse = !this.isCollapse
      this.setKeyCollapse()
    },
    toggleTopMenus() {
      this.showTopMenus = !this.showTopMenus
      setStore({ name: 'showTopMenus', content: this.showTopMenus })
    },
    setScreen(screen) {
      this.screen = screen
      this.setKeyCollapse()
    },
    setKeyCollapse() {
      this.keyCollapse = this.screen > 1 ? this.isCollapse : false
    },
    setTheme(theme) {
      this.theme = theme
      setStore({ name: 'theme', content: theme })
    },
    // 获取系统配置信息
    async loadSystemConfigs() {
      if (this.systemConfigsLoaded) return
      this.systemConfigsLoading = true
      this.systemConfigsLoaded = true
      try {
        const res = (await domainApi.getAll({ domain: window.location.host })).data
        const config = res?.[0] || defaultConfig
        this.systemConfigs = config
        return config
      } catch (e) {
        console.error('Failed to load system configs: ' + e.message)
      } finally {
        this.systemConfigsLoaded = false
        this.systemConfigsLoading = false
      }
    },
    // 设置预览配置
    setPreviewSystemConfig(config) {
      this.previewSystemConfig = config
    },
    // 清除预览配置
    clearPreviewSystemConfig() {
      this.previewSystemConfig = null
    },
    // 获取本地部署
    async loadLocalDeploymentTenant() {
      try {
        const res = await localDeploymentApi.getAll()
        if (res && res.data?.length) {
          const obj = res.data[0]
          this.localDeploymentTenant = obj
          setSession({ name: 'local_deployment_tenant', content: obj })
          return obj
        }
      } catch (error) {
        console.error('Failed to initialize tenant name:', error)
      }
    }
  }
})
